'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _BreadcrumbNode = require('./BreadcrumbNode');

var _BreadcrumbNode2 = _interopRequireDefault(_BreadcrumbNode);

var _taxonomyNodePropType = require('../PropTypes/taxonomyNodePropType');

var _taxonomyNodePropType2 = _interopRequireDefault(_taxonomyNodePropType);

var _constants = require('./constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Breadcrumb = function Breadcrumb(_ref) {
  var nodes = _ref.nodes,
      nodesPlaceholder = _ref.nodesPlaceholder,
      listType = _ref.listType,
      onClickNode = _ref.onClickNode,
      onClickLink = _ref.onClickLink;

  var geonameList = nodesPlaceholder.map(function (placeholder, index) {
    if (nodes[index]) {
      return _react2.default.createElement(_BreadcrumbNode2.default, {
        label: nodes[index].name,
        taxonomyId: index === 0 ? _constants.EARTH_TAXONOMY_ID : nodes[index]._id,
        key: placeholder,
        onClickNode: onClickNode,
        onClickLink: onClickLink
      });
    } else if (listType === 'spots' && index < 5) {
      return null;
    }
    return _react2.default.createElement(_BreadcrumbNode2.default, { label: placeholder, key: placeholder });
  });

  return _react2.default.createElement(
    'div',
    { className: 'quiver-taxonomy-navigator__breadcrumb' },
    geonameList
  );
};

Breadcrumb.propTypes = {
  nodes: _propTypes2.default.arrayOf(_taxonomyNodePropType2.default),
  nodesPlaceholder: _propTypes2.default.arrayOf(_propTypes2.default.string),
  listType: _propTypes2.default.string,
  onClickNode: _propTypes2.default.func,
  onClickLink: _propTypes2.default.func
};

exports.default = Breadcrumb;


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/TaxonomyNavigator/Breadcrumb.js
// module id = 335
// module chunks = 0